export default __webpack_public_path__ + "static/media/Lisk.a63d51d5.png";